import axios from 'axios';
import { API_BASE_URL, API_BASE_URL_PRIVATE, API_BASE_URL_MEMBER } from '../constants/Constants';

const axiosConfig = {
  withCredentials: true,
};

const instanceAPI = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-type': 'application/json' },
});

const instanceAPIPrivate = axios.create({
  baseURL: API_BASE_URL_PRIVATE,
  headers: { 'Content-type': 'application/json' },
  axiosConfig,
});

const instanceAPIMember = axios.create({
  baseURL: API_BASE_URL_MEMBER,
  headers: { 'Content-type': 'application/json' },
  axiosConfig,
});
export { instanceAPIMember, instanceAPIPrivate };
export default instanceAPI;
